import { render, staticRenderFns } from "./TaskDetailsTags.vue?vue&type=template&id=42eb71b2"
import script from "./TaskDetailsTags.vue?vue&type=script&lang=js"
export * from "./TaskDetailsTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports